/**
 * Things that are built but not yet switched on.
 *
 * A flag, rather than deleting the code: the alternative is ripping out a
 * working sign-in path and writing it again later from memory, which is how
 * details like the `prompt: 'select_account'` parameter and the PKCE-safe
 * callback quietly get lost.
 */

/**
 * Sign in with Google.
 *
 * On since 2026-08-21. The OAuth client exists, its id and secret are in
 * Supabase's Google provider, and the consent screen is published — which
 * needed no review because the app asks only for `openid`, `email` and
 * `profile`. The tax details that looked like a blocker were only ever
 * required for a billing account, which OAuth does not use.
 *
 * Verified before flipping: Supabase's authorize endpoint answers 302 to
 * accounts.google.com with the right client id, the callback pointed at
 * Supabase, and `redirect_to` keeping its full path — that last one proving
 * the redirect allow-list finally carries `https://quantifyrapp.com/**`
 * rather than the bare origin.
 *
 * Turning it off again is this flag alone; nothing else in the sign-in path
 * depends on it.
 */
export const GOOGLE_SIGN_IN_ENABLED: boolean = true;
